import { type FC, PropsWithChildren } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { submitLeadFormSchema } from "../Form/SubmitLeadFormSchema.ts";
import { useParams } from "react-router";
import { useGetLeadsQuery } from "features/LeadGen/api";
import { components } from "types/declarations/api";

const LeadDetailsFormProvider: FC<PropsWithChildren> = ({ children }) => {
	const { leadAssignmentId } = useParams();
	const { data: leadsApiData } = useGetLeadsQuery();

	const filterFormData = (leadsApiData: components["schemas"]["LeadAssignmentViewModel"][]) => {
		const assignmentDetails = leadsApiData?.find((lead) => lead.leadAssignmentId === leadAssignmentId);

		return {
			leadStatus: assignmentDetails?.status ?? "",
			followUpDate: assignmentDetails?.followUpDate ?? null,
			assignedToUserId: assignmentDetails?.assignedToUserId ?? null,
			orderNumber: assignmentDetails?.orderNumber ?? "",
			notes: assignmentDetails?.leadAssignmentNotes ?? "",
			declineReason: assignmentDetails?.declineReason ?? ""
		};
	};

	const methods = useForm({
		resolver: yupResolver(submitLeadFormSchema),
		values: leadsApiData ? filterFormData(leadsApiData) : undefined,
		mode: "onChange",
		reValidateMode: "onChange",
		defaultValues: {
			leadStatus: "",
			followUpDate: null,
			assignedToUserId: null,
			orderNumber: "",
			notes: "",
			declineReason: ""
		}
	});

	return <FormProvider {...methods}>{children}</FormProvider>;
};

export default LeadDetailsFormProvider;
